<template>
    <div id="cartao.mensagem">
        <div class="checkout" v-if="modelo == 1">
            <div class="credit-card-box">
                <div class="front-message">
                    <div id="checkout-center" width="100%">
                        <img class="image-center" src="images/imagem_erro.png" height="110px" />
                    </div>
                    <h3 style="margin-top: 10px; text-align: center;"> {{ mensagemUsuario }}  </h3>
                </div>
            </div>
        </div>

        <div class="checkout2" v-if="modelo == 2">
            <div class="checkout-message">
                <div id="checkout-center" width="100%">
                    <img class="image-center" src="images/imagem_ok.png" height="110px" />
                </div>
                <h3>Transação realizada com sucesso!</h3>
                <p><h3>Aguarde a janela fechar automaticamente.</h3></p>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: 'cartao.mensagem',
    props: [
        'modelo',
        'mensagem'
    ],
    directives: {

    },
    components: {

    },
    data() {
        return {

        }
    },
    computed: {
        mensagemUsuario() {
            return this.mensagem ?? "Transação inválida !";
        }
    },
    mounted() {
        const vm = this;

    },
    destroyed(){

    },
    updated: function () {
        this.$nextTick(function () {
            if (this.modelo === 2) {

            }
        });
    },
    methods: {

    }
}
</script>

<style scoped>
*,
*::before,
*::after {
    box-sizing: border-box;
}
html,
body {
    min-height: 100%;
    font-family: 'Open sans', sans-serif;
}

body {
    background: #f1efee;
    /* linear-gradient(50deg, #f3c680, #a1e3e2); */
}

/*--------------------
Checkout
--------------------*/
.checkout {
    margin: 150px auto 30px;
    position: relative;
    width: 460px;
    background: white;
    border-radius: 15px;
    padding: 160px 45px 30px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.image-center {
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.checkout-message {
    margin: 50px auto 30px;
    position: relative;
    width: 460px;
    background: white;
    border-radius: 15px;
    padding: 50px 45px 30px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

/*--------------------
Credit Card
--------------------*/
.credit-card-box {
    -webkit-perspective: 1000px;
    perspective: 1000px;
    width: 400px;
    height: 280px;
    position: absolute;
    top: -112px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
}
.credit-card-box:hover .flip, .credit-card-box.hover .flip {
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
}

@media screen and (max-width: 768px) {

}

.credit-card-box .front,
.credit-card-box .back {
    width: 400px;
    height: 250px;
    border-radius: 15px;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    background: linear-gradient(135deg, #bd6772, #53223f);
    position: absolute;
    color: #fff;
    font-family: Inconsolata;
    top: 0;
    left: 0;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}

.credit-card-box .front::before,
.credit-card-box .back::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    /*background: url("https://app.sobdemanda.net/images/44386.svg") no-repeat center;*/
    background-size: cover;
    opacity: .05;
}
.credit-card-box .flip {
    -webkit-transition: 0.6s;
    transition: 0.6s;
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
    position: relative;
}
.credit-card-box .logo {
    position: absolute;
    top: 9px;
    right: 20px;
    width: 60px;
}
.credit-card-box .logo svg {
    width: 100%;
    height: auto;
    fill: #fff;
}
.credit-card-box .front {
    z-index: 2;
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
}
.credit-card-box .back {
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
}
.credit-card-box .back .logo {
    top: 185px;
}
.credit-card-box .chip {
    position: absolute;
    width: 60px;
    height: 45px;
    top: 20px;
    left: 20px;
    background: linear-gradient(135deg, #ddccf0 0%, #d1e9f5 44%, #f8ece7 100%);
    border-radius: 8px;
}
.credit-card-box .chip::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border: 4px solid rgba(128, 128, 128, 0.1);
    width: 80%;
    height: 70%;
    border-radius: 5px;
}
.credit-card-box .strip {
    background: linear-gradient(135deg, #404040, #1a1a1a);
    position: absolute;
    width: 100%;
    height: 50px;
    top: 30px;
    left: 0;
}
.credit-card-box .number {
    position: absolute;
    margin: 0 auto;
    top: 103px;
    left: 19px;
    font-size: 38px;
}
.credit-card-box label {
    font-size: 10px;
    letter-spacing: 1px;
    text-shadow: none;
    text-transform: uppercase;
    font-weight: normal;
    opacity: 0.5;
    display: block;
    margin-bottom: 3px;
}
.credit-card-box .card-holder,
.credit-card-box .card-expiration-date {
    position: absolute;
    margin: 0 auto;
    top: 180px;
    left: 19px;
    font-size: 22px;
    text-transform: capitalize;
}
.credit-card-box .card-expiration-date {
    text-align: right;
    left: auto;
    right: 20px;
}
.credit-card-box .ccv {
    height: 36px;
    background: #fff;
    width: 91%;
    border-radius: 5px;
    top: 110px;
    left: 0;
    right: 0;
    position: absolute;
    margin: 0 auto;
    color: #000;
    text-align: right;
    padding: 10px;
}
.credit-card-box .ccv label {
    margin: -25px 0 14px;
    color: #fff;
}

.the-most {
    position: fixed;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 50vw;
    max-width: 200px;
    padding: 10px;
}
.the-most img {
    max-width: 100%;
}

.credit-card-box .front-message,
.credit-card-box .back-message {
    width: 400px;
    /*height: 250px;*/
    border-radius: 15px;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    background: linear-gradient(135deg, #bd6772, #53223f);
    position: absolute;
    color: #fff;
    font-family: Inconsolata;
    top: 0;
    left: 0;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}

.credit-card-box .front-message::before,
.credit-card-box .back-message::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-size: cover;
    opacity: .05;
}
</style>
